import { ApiBase } from '../api-base'

export class ContractorEmployeeAccessServices extends ApiBase {
  constructor () {
    super({
      resource: '/api/v1/contractor/employee_access',
      name: 'contractorEmployeeAccess',
      successPath: '/'
    })
  }

  getOffices () {
    return this.api
      .get('/api/v1/accounts/offices?own=true')
      .then(response => response.data.offices)
  }

  companyCheck () {
    return this.api
      .get(`${this.resource}/company_check`)
      .then(response => response.data)
  }

  checkAccess (documentNumber, officeId = null) {
    const params = new URLSearchParams()
    if (documentNumber) params.append('document_number', documentNumber)
    if (officeId) params.append('office_id', officeId)

    return this.api
      .get(`${this.resource}/check_access?${params.toString()}`)
      .then(response => response.data)
  }
}
